import { ACCOUNT_SUSPENSION, POPUP_CLOSE_MASTER } from "../actions/types";

const initialState = { suspensionReason: [], assignBtnClick: false };

const accountSuspensionReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ACCOUNT_SUSPENSION:
      return {
        ...state,
        suspensionReason: payload,
      };
    case POPUP_CLOSE_MASTER:
      return {
        ...state,
        assignBtnClick: payload,
      };
    default:
      return state;
  }
};

export { accountSuspensionReducer };
